import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { ProfileImageSize, BaseViewComponent, ButtonKind, ButtonSize, FieldOf, ItemWithID, ProfileCardMode } from '@sb/library/base';

@Component({
    selector: 'lib-profile-button',
    templateUrl: './profile-button.component.html',
    styleUrl: './profile-button.component.scss'
})
export class ProfileButtonComponent<T extends ItemWithID> extends BaseViewComponent implements AfterViewInit {
    @Input() size: ButtonSize = ButtonSize.Medium;
    @Input() kind: ButtonKind.Link | ButtonKind.NeutralLink = ButtonKind.Link;
    @Input({ required: true }) displayItem!: T;
    @Input() hasImage: boolean = false;
    @Input() imageURL: string | null = null;
    @Input() profileURL: string | null = null;
    @Input() qaTag: string = '';
    @Input() truncate: boolean = false;
    @Output() clicked: EventEmitter<void> = new EventEmitter();
    

    private _avatarSize: ProfileImageSize = ProfileImageSize.Medium;
    private _name: string = '';

    ngAfterViewInit(): void {
        switch (this.size) {
            case ButtonSize.Medium:
                this._avatarSize = ProfileImageSize.Medium;
                break;
            case ButtonSize.Small:
                this._avatarSize = ProfileImageSize.Small ;
                break;
        }
        this._name = this.GetName();
    }

    ButtonClicked(): void {
        this.clicked.emit();
    }

    private GetName(): string {
        let name = '';
        let nameBy: FieldOf<T> | undefined = undefined;
        const keys = Object.keys(this.displayItem);
        const hasFirstNameField = keys.includes('FirstName');

        if (keys.includes('FullName')) {
            nameBy = 'FullName' as FieldOf<T>;
        } else if (keys.includes('Name')) {
            nameBy = 'Name' as FieldOf<T>;
        } else {
            throw Error(`Could not determine a field to use as a name when setting up (${this.constructor.name}).`);
        }

        name = this.displayItem[nameBy!] as unknown as string;
        return name;
    }

    get avatarSize(): ProfileImageSize {
        return this._avatarSize;
    }

    get name(): string {
        return this._name;
    }
}
